import React, { useEffect, useState } from 'react';
import { PanelResult } from '@interfaces/central-monitoring';
import { DisplayPanel } from '@pages-clean/central-monitoring/data-view/panels/panel';
import Loading from 'views/components/core/loading';
import { useTranslation } from '@hooks/index';
import { PanelFields } from '@queries/generated/fragments.generated';
import { useGetPanelPreview } from '@apis/bff-api/central-monitoring';
import 'views/components/central-monitoring/panels/add-panel/styles.scss';

type PanelProps = {
    studyRef: string;
    panelState: PanelFields;
};

export const PanelPreview = ({ studyRef, panelState }: PanelProps) => {
    const { trigger: preview, error, isMutating } = useGetPanelPreview(studyRef);
    const [latestCMPanelData, setLatestCMPanelData] = useState<PanelResult>();

    useEffect(() => {
        preview(JSON.stringify(panelState))
            .then((payload: PanelResult) => {
                setLatestCMPanelData(payload);
            })
            .catch(() => {});
    }, []);

    const { panelType, graph, modelParams, panelTheme, dataSource } = panelState;

    const { t } = useTranslation('cm');
    return (
        <div>
            {isMutating && <Loading />}
            {!isMutating && !latestCMPanelData && (
                <h1 className="no-data"> {t('componentsClean.panels.noDataForPreview')}</h1>
            )}
            {!isMutating && latestCMPanelData && (
                <DisplayPanel
                    panelType={panelType}
                    graph={graph}
                    modelParams={modelParams}
                    panelTheme={panelTheme}
                    dataSource={dataSource}
                    testId="panel-preview"
                    nonFilterable
                    showWaterMark={false}
                    screenFilterable={false}
                    panelData={latestCMPanelData}
                    error={error}
                    isPreview
                />
            )}
        </div>
    );
};
